
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Blogger Program',
    howItWorks: 'How it works',

    step1Title: 'Create a quality review',
    step1Description: 'Record a video with a full review of SHOT bot. We recommend showing:',
    step1Item1: 'All bot features',
    step1Item2: 'Case openings',
    step1Item3: 'Main features',

    step2Title: 'Post on Instagram or TikTok',
    step2Description:
      'Post the video on your Instagram or TikTok account. Make sure to add hashtags: #cs_shot_bot #cs2. More views — more rewards!',

    step3Title: 'Contact us',
    step3Description: 'Send a link to your video in private messages to',
    step3Channel: 'SHOT Friends',

    step4Title: 'Get rewarded',
    step4DescriptionPrefix: 'After video verification you will receive',
    step4DescriptionMiddle: 'for',
    step4DescriptionViews: '100,000 views',
    step4DescriptionSuffix: 'Payouts from 10,000 views once a week. We will create a tracking table.',

    warningTitle: 'Important rules',
    warningCheck: '⚠️ Fraud check:',
    warningCheckText:
      'We carefully verify all views for authenticity. We use special tools to detect fake views.',
    warningBan: '🚫 Ban:',
    warningBanText: 'Accounts caught using fake views will be permanently banned without any payouts.',
    warningHonest: '✅ Honesty:',
    warningHonestText: 'Play fair — get consistent rewards for quality content!',

    contactTitle: 'How to participate',
    contactDescription:
      'To participate in the program, message SHOT Friends channel. Send a link to your social media and specify the number of subscribers and average views on your videos.',
    contactButton: 'Message SHOT Friends',
  },
  ru: {
    title: 'Программа для блогеров',
    howItWorks: 'Как это работает',

    step1Title: 'Создай качественный обзор',
    step1Description: 'Сними видео с полным обзором бота SHOT. Рекомендуем показать:',
    step1Item1: 'Весь функционал бота',
    step1Item2: 'Прокрутку кейсов',
    step1Item3: 'Основные возможности',

    step2Title: 'Опубликуй в Instagram или TikTok',
    step2Description:
      'Размести видео на своём аккаунте в Instagram или TikTok. Обязательно поставь хэштеги: #cs_shot_bot #cs2. Чем больше просмотров — тем больше вознаграждение!',

    step3Title: 'Напиши нам',
    step3Description: 'Отправь ссылку на своё видео в личные сообщения канала',
    step3Channel: 'SHOT Friends',

    step4Title: 'Получай награду',
    step4DescriptionPrefix: 'После проверки видео получишь',
    step4DescriptionMiddle: 'за',
    step4DescriptionViews: '100 000 просмотров',
    step4DescriptionSuffix: 'Выплаты от 10 000 просмотров 1 раз в неделю. Сделаем таблицу для учета.',

    warningTitle: 'Важные правила',
    warningCheck: '⚠️ Проверка на накрутку:',
    warningCheckText:
      'Мы тщательно проверяем все просмотры на подлинность. Используем специальные инструменты для выявления накрутки.',
    warningBan: '🚫 Блокировка:',
    warningBanText:
      'Аккаунты, замеченные в накрутке просмотров, будут заблокированы навсегда без каких-либо выплат.',
    warningHonest: '✅ Честность:',
    warningHonestText: 'Делай все честно — получай стабильные вознаграждения за качественный контент!',

    contactTitle: 'Как принять участие',
    contactDescription:
      'Чтобы принять участие в программе, напиши в личные сообщения канала SHOT Friends. Отправь ссылку на свои соц сети и укажи количество подписчиков и сколько в среднем набирают просмотров твои видео.',
    contactButton: 'Написать в SHOT Friends',
  },
  uz: {
    title: 'Blogerlar dasturi',
    howItWorks: 'Bu qanday ishlaydi',

    step1Title: 'Sifatli sharh yarating',
    step1Description: 'SHOT boti haqida toʻliq sharh videosini yozing. Koʻrsatishni tavsiya qilamiz:',
    step1Item1: 'Botning barcha funksiyalari',
    step1Item2: 'Keys ochish',
    step1Item3: 'Asosiy imkoniyatlar',

    step2Title: 'Instagram yoki TikTokda joylashtiring',
    step2Description:
      'Videoni Instagram yoki TikTok akkauntingizda joylashtiring. Xeshteglarni qoʻshishni unutmang: #cs_shot_bot #cs2. Koʻrishlar qancha koʻp boʻlsa, mukofot ham shuncha koʻp!',

    step3Title: 'Bizga yozing',
    step3Description: 'Videongizga havolani shaxsiy xabarlarda yuboring:',
    step3Channel: 'SHOT Friends',

    step4Title: 'Mukofot oling',
    step4DescriptionPrefix: 'Video tekshirilgandan soʻng',
    step4DescriptionMiddle: 'uchun',
    step4DescriptionViews: '100 000 koʻrish',
    step4DescriptionSuffix: 'olasiz! Haftada bir marta 10 000 koʻrishdan toʻlovlar. Hisobni yuritish uchun jadval yaratamiz.',

    warningTitle: 'Muhim qoidalar',
    warningCheck: '⚠️ Firibgarlikni tekshirish:',
    warningCheckText:
      'Biz barcha koʻrishlarni haqiqiyligi uchun sinchkovlik bilan tekshiramiz. Soxta koʻrishlarni aniqlash uchun maxsus vositalardan foydalanamiz.',
    warningBan: '🚫 Bloklash:',
    warningBanText:
      'Soxta koʻrishlar foydalangan akkauntlar hech qanday toʻlovsiz abadiy bloklanadi.',
    warningHonest: '✅ Halollik:',
    warningHonestText: 'Halol oʻynang — sifatli kontent uchun barqaror mukofotlar oling!',

    contactTitle: 'Qanday ishtirok etish mumkin',
    contactDescription:
      'Dasturda ishtirok etish uchun SHOT Friends kanaliga xabar yozing. Ijtimoiy tarmoqlaringizga havola yuboring va obunachilar soni hamda videolaringiz oʻrtacha qancha koʻrish toʻplayotganini koʻrsating.',
    contactButton: 'SHOT Friendsga yozish',
  },
  fa: {
    title: 'برنامه بلاگرها',
    howItWorks: 'چطور کار می‌کند',

    step1Title: 'یک ریویو باکیفیت بساز',
    step1Description: 'ویدیویی با ریویوی کامل ربات SHOT ضبط کن. پیشنهاد می‌کنیم این‌ها را نشان بدهی:',
    step1Item1: 'همه امکانات ربات',
    step1Item2: 'باز کردن کیس',
    step1Item3: 'قابلیت‌های اصلی',

    step2Title: 'در اینستاگرام یا تیک‌تاک بگذار',
    step2Description:
      'ویدیو را در اینستاگرام یا تیک‌تاکت بگذار. حتماً هشتگ‌ها را اضافه کن: #cs_shot_bot #cs2. بازدید بیشتر — جایزه بیشتر!',

    step3Title: 'با ما تماس بگیر',
    step3Description: 'لینک ویدیویت را در پیام خصوصی بفرست به',
    step3Channel: 'SHOT Friends',

    step4Title: 'جایزه بگیر',
    step4DescriptionPrefix: 'بعد از بررسی ویدیو می‌گیری',
    step4DescriptionMiddle: 'برای',
    step4DescriptionViews: '100,000 بازدید',
    step4DescriptionSuffix: 'پرداخت از 10,000 بازدید، هفته‌ای یک بار. یک جدول پیگیری می‌سازیم.',

    warningTitle: 'قوانین مهم',
    warningCheck: '⚠️ بررسی تقلب:',
    warningCheckText: 'همه بازدیدها را با دقت بررسی می‌کنیم. برای پیدا کردن بازدید تقلبی ابزار مخصوص داریم.',
    warningBan: '🚫 مسدودی:',
    warningBanText: 'حساب‌هایی که با بازدید تقلبی گرفته شوند برای همیشه و بدون هیچ پرداختی مسدود می‌شوند.',
    warningHonest: '✅ صداقت:',
    warningHonestText: 'منصفانه بازی کن — برای محتوای باکیفیت جایزه همیشگی بگیر!',

    contactTitle: 'چطور شرکت کنیم',
    contactDescription:
      'برای شرکت در برنامه به کانال SHOT Friends پیام بده. لینک شبکه اجتماعیت را بفرست و تعداد دنبال‌کننده و میانگین بازدید ویدیوهایت را بنویس.',
    contactButton: 'پیام به SHOT Friends',
  },
  pt: {
    title: 'Programa para criadores',
    howItWorks: 'Como funciona',

    step1Title: 'Faça um review de qualidade',
    step1Description: 'Grave um vídeo com um review completo do bot SHOT. Recomendamos mostrar:',
    step1Item1: 'Todas as funções do bot',
    step1Item2: 'Abertura de caixas',
    step1Item3: 'Principais recursos',

    step2Title: 'Publique no Instagram ou TikTok',
    step2Description:
      'Publique o vídeo na sua conta do Instagram ou TikTok. Não esqueça das hashtags: #cs_shot_bot #cs2. Quanto mais visualizações — maior a recompensa!',

    step3Title: 'Fale com a gente',
    step3Description: 'Mande o link do seu vídeo por mensagem privada para o canal',
    step3Channel: 'SHOT Friends',

    step4Title: 'Receba a recompensa',
    step4DescriptionPrefix: 'Depois da verificação do vídeo você recebe',
    step4DescriptionMiddle: 'a cada',
    step4DescriptionViews: '100.000 visualizações',
    step4DescriptionSuffix: 'Pagamentos a partir de 10.000 visualizações, uma vez por semana. Vamos criar uma tabela de acompanhamento.',

    warningTitle: 'Regras importantes',
    warningCheck: '⚠️ Verificação de fraude:',
    warningCheckText:
      'Verificamos com cuidado a autenticidade de todas as visualizações. Usamos ferramentas especiais para detectar visualizações falsas.',
    warningBan: '🚫 Banimento:',
    warningBanText: 'Contas flagradas com visualizações falsas serão banidas para sempre, sem nenhum pagamento.',
    warningHonest: '✅ Honestidade:',
    warningHonestText: 'Jogue limpo — receba recompensas constantes por conteúdo de qualidade!',

    contactTitle: 'Como participar',
    contactDescription:
      'Para participar do programa, mande mensagem privada para o canal SHOT Friends. Envie o link das suas redes sociais e informe o número de seguidores e a média de visualizações dos seus vídeos.',
    contactButton: 'Escrever para SHOT Friends',
  },
  tr: {
    title: 'İçerik üreticisi programı',
    howItWorks: 'Nasıl çalışır',

    step1Title: 'Kaliteli bir inceleme hazırla',
    step1Description: 'SHOT botunun tam incelemesini içeren bir video çek. Şunları göstermeni öneririz:',
    step1Item1: 'Botun tüm işlevleri',
    step1Item2: 'Kasa açılışları',
    step1Item3: 'Ana özellikler',

    step2Title: "Instagram'da ya da TikTok'ta paylaş",
    step2Description:
      "Videoyu Instagram ya da TikTok hesabında paylaş. Hashtag'leri eklemeyi unutma: #cs_shot_bot #cs2. Ne kadar çok izlenme — o kadar çok ödül!",

    step3Title: 'Bize yaz',
    step3Description: 'Videonun linkini özel mesajla şu kanala gönder:',
    step3Channel: 'SHOT Friends',

    step4Title: 'Ödülünü al',
    step4DescriptionPrefix: 'Video kontrol edildikten sonra',
    step4DescriptionMiddle: 'alırsın — her',
    step4DescriptionViews: '100.000 izlenme için',
    step4DescriptionSuffix: 'Ödemeler 10.000 izlenmeden itibaren, haftada 1 kez. Takip için bir tablo oluşturacağız.',

    warningTitle: 'Önemli kurallar',
    warningCheck: '⚠️ Sahte izlenme kontrolü:',
    warningCheckText:
      'Tüm izlenmelerin gerçekliğini dikkatle kontrol ediyoruz. Sahte izlenmeleri tespit etmek için özel araçlar kullanıyoruz.',
    warningBan: '🚫 Yasaklama:',
    warningBanText: 'Sahte izlenme kullandığı tespit edilen hesaplar, hiçbir ödeme yapılmadan kalıcı olarak yasaklanır.',
    warningHonest: '✅ Dürüstlük:',
    warningHonestText: 'Dürüst oyna — kaliteli içerik için düzenli ödül al!',

    contactTitle: 'Nasıl katılırım',
    contactDescription:
      'Programa katılmak için SHOT Friends kanalına özel mesaj yaz. Sosyal medya hesaplarının linkini gönder, takipçi sayını ve videolarının ortalama izlenmesini belirt.',
    contactButton: "SHOT Friends'e yaz",
  },
  uk: {
    title: 'Програма для блогерів',
    howItWorks: 'Як це працює',

    step1Title: 'Створи якісний огляд',
    step1Description: 'Зніми відео з повним оглядом бота SHOT. Рекомендуємо показати:',
    step1Item1: 'Увесь функціонал бота',
    step1Item2: 'Прокрутку кейсів',
    step1Item3: 'Основні можливості',

    step2Title: 'Опублікуй в Instagram або TikTok',
    step2Description:
      'Розмісти відео на своєму акаунті в Instagram або TikTok. Обов’язково додай хештеги: #cs_shot_bot #cs2. Що більше переглядів — то більша винагорода!',

    step3Title: 'Напиши нам',
    step3Description: 'Надішли посилання на своє відео в особисті повідомлення каналу',
    step3Channel: 'SHOT Friends',

    step4Title: 'Отримуй винагороду',
    step4DescriptionPrefix: 'Після перевірки відео отримаєш',
    step4DescriptionMiddle: 'за',
    step4DescriptionViews: '100 000 переглядів',
    step4DescriptionSuffix: 'Виплати від 10 000 переглядів раз на тиждень. Зробимо таблицю для обліку.',

    warningTitle: 'Важливі правила',
    warningCheck: '⚠️ Перевірка на накрутку:',
    warningCheckText:
      'Ми ретельно перевіряємо всі перегляди на справжність. Використовуємо спеціальні інструменти для виявлення накрутки.',
    warningBan: '🚫 Блокування:',
    warningBanText: 'Акаунти, помічені в накрутці переглядів, буде заблоковано назавжди без жодних виплат.',
    warningHonest: '✅ Чесність:',
    warningHonestText: 'Грай чесно — отримуй стабільні винагороди за якісний контент!',

    contactTitle: 'Як узяти участь',
    contactDescription:
      'Щоб узяти участь у програмі, напиши в особисті повідомлення каналу SHOT Friends. Надішли посилання на свої соцмережі та вкажи кількість підписників і скільки в середньому набирають переглядів твої відео.',
    contactButton: 'Написати в SHOT Friends',
  },
  de: {
    title: 'Programm für Blogger',
    howItWorks: 'So funktioniert’s',

    step1Title: 'Erstelle ein gutes Review',
    step1Description: 'Nimm ein Video mit einem vollständigen Review des SHOT-Bots auf. Wir empfehlen zu zeigen:',
    step1Item1: 'Alle Funktionen des Bots',
    step1Item2: 'Case Openings',
    step1Item3: 'Die wichtigsten Features',

    step2Title: 'Poste auf Instagram oder TikTok',
    step2Description:
      'Poste das Video auf deinem Instagram- oder TikTok-Account. Füge unbedingt die Hashtags hinzu: #cs_shot_bot #cs2. Mehr Views – mehr Belohnung!',

    step3Title: 'Schreib uns',
    step3Description: 'Schick den Link zu deinem Video per Direktnachricht an',
    step3Channel: 'SHOT Friends',

    step4Title: 'Hol dir deine Belohnung',
    step4DescriptionPrefix: 'Nach der Prüfung des Videos bekommst du',
    step4DescriptionMiddle: 'für',
    step4DescriptionViews: '100.000 Views',
    step4DescriptionSuffix: 'Auszahlungen ab 10.000 Views einmal pro Woche. Wir legen eine Tabelle zur Erfassung an.',

    warningTitle: 'Wichtige Regeln',
    warningCheck: '⚠️ Betrugsprüfung:',
    warningCheckText:
      'Wir prüfen alle Views sorgfältig auf Echtheit. Wir nutzen spezielle Tools, um gefälschte Views zu erkennen.',
    warningBan: '🚫 Sperre:',
    warningBanText: 'Accounts, die mit gefälschten Views erwischt werden, werden dauerhaft und ohne Auszahlungen gesperrt.',
    warningHonest: '✅ Fairness:',
    warningHonestText: 'Spiel fair – und hol dir stabile Belohnungen für gute Inhalte!',

    contactTitle: 'So machst du mit',
    contactDescription:
      'Um am Programm teilzunehmen, schreib dem Kanal SHOT Friends eine Direktnachricht. Schick den Link zu deinen Social-Media-Profilen und gib deine Followerzahl und die durchschnittlichen Views deiner Videos an.',
    contactButton: 'SHOT Friends schreiben',
  },
  es: {
    title: 'Programa para bloggers',
    howItWorks: 'Cómo funciona',

    step1Title: 'Crea una reseña de calidad',
    step1Description: 'Graba un vídeo con una reseña completa del bot de SHOT. Recomendamos mostrar:',
    step1Item1: 'Todas las funciones del bot',
    step1Item2: 'Aperturas de cajas',
    step1Item3: 'Las funciones principales',

    step2Title: 'Publica en Instagram o TikTok',
    step2Description:
      'Publica el vídeo en tu cuenta de Instagram o TikTok. No olvides añadir los hashtags: #cs_shot_bot #cs2. Más visualizaciones, más recompensa.',

    step3Title: 'Escríbenos',
    step3Description: 'Envía el enlace de tu vídeo por mensaje privado al canal',
    step3Channel: 'SHOT Friends',

    step4Title: 'Recibe tu recompensa',
    step4DescriptionPrefix: 'Tras verificar el vídeo recibirás',
    step4DescriptionMiddle: 'por',
    step4DescriptionViews: '100 000 visualizaciones',
    step4DescriptionSuffix: 'Pagos desde 10 000 visualizaciones, una vez por semana. Haremos una tabla de seguimiento.',

    warningTitle: 'Reglas importantes',
    warningCheck: '⚠️ Revisión de fraude:',
    warningCheckText:
      'Verificamos con cuidado la autenticidad de todas las visualizaciones. Usamos herramientas especiales para detectar visualizaciones falsas.',
    warningBan: '🚫 Bloqueo:',
    warningBanText: 'Las cuentas sorprendidas con visualizaciones falsas serán bloqueadas para siempre y sin ningún pago.',
    warningHonest: '✅ Honestidad:',
    warningHonestText: 'Juega limpio y recibe recompensas estables por contenido de calidad.',

    contactTitle: 'Cómo participar',
    contactDescription:
      'Para participar en el programa, escribe por mensaje privado al canal SHOT Friends. Envía el enlace a tus redes sociales e indica cuántos seguidores tienes y cuántas visualizaciones logran en promedio tus vídeos.',
    contactButton: 'Escribir a SHOT Friends',
  },
  pl: {
    title: 'Program dla blogerów',
    howItWorks: 'Jak to działa',

    step1Title: 'Zrób porządną recenzję',
    step1Description: 'Nagraj wideo z pełną recenzją bota SHOT. Polecamy pokazać:',
    step1Item1: 'Wszystkie funkcje bota',
    step1Item2: 'Otwieranie skrzynek',
    step1Item3: 'Najważniejsze funkcje',

    step2Title: 'Opublikuj na Instagramie lub TikToku',
    step2Description:
      'Wrzuć wideo na swoje konto na Instagramie lub TikToku. Koniecznie dodaj hashtagi: #cs_shot_bot #cs2. Im więcej wyświetleń, tym większa nagroda!',

    step3Title: 'Napisz do nas',
    step3Description: 'Wyślij link do swojego wideo w wiadomości prywatnej do kanału',
    step3Channel: 'SHOT Friends',

    step4Title: 'Odbierz nagrodę',
    step4DescriptionPrefix: 'Po weryfikacji wideo dostaniesz',
    step4DescriptionMiddle: 'za',
    step4DescriptionViews: '100 000 wyświetleń',
    step4DescriptionSuffix: 'Wypłaty od 10 000 wyświetleń raz w tygodniu. Zrobimy tabelę do rozliczeń.',

    warningTitle: 'Ważne zasady',
    warningCheck: '⚠️ Kontrola nabijania:',
    warningCheckText:
      'Starannie sprawdzamy autentyczność wszystkich wyświetleń. Używamy specjalnych narzędzi do wykrywania nabijania.',
    warningBan: '🚫 Blokada:',
    warningBanText: 'Konta przyłapane na nabijaniu wyświetleń zostaną zablokowane na zawsze bez żadnych wypłat.',
    warningHonest: '✅ Uczciwość:',
    warningHonestText: 'Graj fair – zdobywaj stabilne nagrody za jakościowe treści!',

    contactTitle: 'Jak wziąć udział',
    contactDescription:
      'Żeby wziąć udział w programie, napisz w wiadomości prywatnej do kanału SHOT Friends. Wyślij link do swoich social mediów i podaj liczbę obserwujących oraz średnią liczbę wyświetleń twoich wideo.',
    contactButton: 'Napisz do SHOT Friends',
  },
});
